import { ActiveCustomerLocationContext } from 'app/store/types/user-context-types';
import { Button } from '@lyse-as/formds-react';
import { useAppNavigation } from 'app/utils/navigation-utils';
import { useAppDispatch } from 'app/hooks/redux-thunk';
import { dismissContactDetailsToastMessage } from 'app/store/actions/contact-details-actions';
import { navigationService } from 'app/service/navigation/navigation-service';
import { useTranslation } from 'react-i18next';
import { AuthLevelPromptContainer } from 'app/features/auth/auth-level-prompt-container';
import styles from './contact-details.module.scss';

interface Props {
  contactDetails: MinesiderBackend.CustomerDetails;
  userContext: ActiveCustomerLocationContext;
}

export const EditButton = ({ contactDetails, userContext }: Props) => {
  const canEditDetails = contactDetails?.isEnterprise !== true && userContext.role === 'PRIMARY';
  const { goToPath } = useAppNavigation();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  if (!canEditDetails) {
    return null;
  }

  return (
    <AuthLevelPromptContainer>
      <Button
        variant="outlined"
        scheme="primary"
        onClick={() => {
          dispatch(dismissContactDetailsToastMessage());
          goToPath(navigationService.PAGES.contactDetailsEdit.url);
        }}
        className={styles.editButton}
      >
        {t('pages.contactDetails.buttons.edit')}
      </Button>
    </AuthLevelPromptContainer>
  );
};
